const initialState = {
    gidValue:[],
};
export const actionTypes = {
    REFRESH_GID_VAULE:"REFRESH_GID_VAULE",
};

export const actions = {
    refresh_gid_value: function (data) {
        return {
            type: actionTypes.REFRESH_GID_VAULE,
            data
        }
    }
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.REFRESH_GID_VAULE:{
            return {...state,gidValue:action.data}
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/groupReducer.js